import React, { useEffect, useState } from 'react'

import pill from "./../../../UI/general/pill.svg"

/*eslint-disable */

interface BrochuresComponentProps {
    isBrochureActive: boolean,
    amenityData: any,
    handleCloseBrochure: any,
    colorsData: any
}

const BrochuresComponent = ({
    isBrochureActive,
    amenityData,
    handleCloseBrochure,
    colorsData
}: BrochuresComponentProps) => {

    const [isCollapsed, setIsCollapsed] = useState(false)
    const [currentSelectedBrochure, setCurrentSelectedBrochure] = useState("")
    const [currentSelectedBrochureIndex, setCurrentSelectedBrochureIndex] = useState(0)

    useEffect(() => {
        if(isBrochureActive && amenityData){
            setCurrentSelectedBrochure(amenityData.links[0].link)
        }
    }, [isBrochureActive])

    const handleChangeTour = (tour: any, index: number) => {
        setCurrentSelectedBrochure(tour)
        setCurrentSelectedBrochureIndex(index)
    }

    return(
        <React.Fragment>
            <div 
            className={isBrochureActive ? 'brochure-container fade-in':'brochure-container fade-out'}
        >
            {
                isBrochureActive ?
                <div className={isCollapsed ? 'brochure-container-wide':'brochure-container-files'}>
                    <div className='brochure-container-file'>
                        <embed src={currentSelectedBrochure}/>
                    </div>
                </div>:null
            }
            <div
                className={isCollapsed ? 'sidebar-brochure-btn-collapsed':'sidebar-brochure-btn'}
                onClick={() => {handleCloseBrochure()}}
            >
                <img src={pill} alt=""/>
            </div>
            <div 
                className={isCollapsed ? 'sidebar-brochure-container-collapsed':'sidebar-brochure-container-alt'}
            >
                <div className='sidebar-brochure-preview-container'>
                {
                            amenityData && amenityData.links ?
                            amenityData.links.map((tours: any, index: number) => 
                                <div 
                                    className='individual-tour-container'
                                    onClick = {() => {
                                        handleChangeTour(tours.link, index)
                                    }}
                                >
                                    <div 
                                        className='individual-tour-image-container-alt'
                                        style={{
                                            boxSizing: 'border-box',
                                            backgroundColor: currentSelectedBrochureIndex === index ? colorsData.main_buttons:'transparent',
                                            color: currentSelectedBrochureIndex === index ? colorsData.secondary_text:colorsData.main_text,
                                        }}
                                    >
                                        <div >
                                        {tours.name}
                                    </div>
                                    </div>
                                </div>
                            ):null
                        }
                </div>
            </div>
        </div>
        </React.Fragment>
    )
}

export default BrochuresComponent